<template>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth">
        <div class="row flex-grow">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left p-5">
              <div class="brand-logo">
                <img src="../../assets/images/maxcess-logo.png" />
              </div>
              <h4>Hello! let's get started</h4>
              <h6 class="font-weight-light">Sign in to continue.</h6>

              <BForm @submit.prevent="onSubmit" class="pt-3">
                <div class="form-group">
                  <BFormInput
                    id="inline-form-input-name"
                    class="form-control form-control-lg"
                    v-model="form.username"
                    placeholder="username"
                    :state="is_valid_user_name"
                    aria-describedby="input_error_user_name"
                    maxlength="30"
                    minlength="10"
                  />
                  <BFormInvalidFeedback id="input_error_user_name">
                    Enter username
                  </BFormInvalidFeedback>
                </div>

                <div class="form-group">
                  <div class="mt-3" v-if="showPass">
                    <BInputGroup>
                      <template #append>
                        <BInputGroupText
                          style="font-size: 1.2rem"
                          @click="showPass = false"
                          ><i class="mdi mdi-eye"></i>
                        </BInputGroupText>
                      </template>
                      <BFormInput
                        id="input_error_user_pass"
                        v-model="form.password"
                        class="form-control form-control-lg"
                        placeholder="Password"
                        :state="is_valid_user_pass"
                        aria-describedby="input_error_user_pass"
                        title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                        minlength="8"
                        maxlength="100"
                      />
                    </BInputGroup>
                    <BFormInvalidFeedback
                      id="input_error_user_pass"
                      style="display: block"
                      v-if="is_valid_user_pass != null && !is_valid_user_pass"
                    >
                      Enter password
                    </BFormInvalidFeedback>
                  </div>

                  <div class="mt-3" v-if="!showPass">
                    <BInputGroup>
                      <template #append>
                        <BInputGroupText
                          style="font-size: 1.2rem"
                          @click="showPass = true"
                          ><i class="mdi mdi-eye-off"></i>
                        </BInputGroupText>
                      </template>
                      <BFormInput
                        id="input_error_user_pass"
                        v-model="form.password"
                        type="password"
                        class="form-control form-control-lg"
                        placeholder="Password"
                        :state="is_valid_user_pass"
                        aria-describedby="input_error_user_pass"
                        title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                        minlength="8"
                        maxlength="100"
                      />
                    </BInputGroup>
                    <BFormInvalidFeedback
                      id="input_error_user_pass"
                      style="display: block"
                      v-if="is_valid_user_pass != null && !is_valid_user_pass"
                    >
                      Enter password
                    </BFormInvalidFeedback>
                  </div>
                </div>
                <div
                  class="mt-3 d-flex justify-content-between align-items-center"
                >
                  <BButton
                    class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                    type="submit"
                    >Sign In
                  </BButton>
                  <router-link to="/forgot-password" class="text-info">
                    Forgot Password?
                  </router-link>
                </div>
                <div
                  class="my-2 d-flex justify-content-between align-items-center"
                >
                  <!-- <div class="text-muted">
                    <BFormCheckbox
                      id="checkbox-1"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                    >
                      Keep me signed in</BFormCheckbox
                    >
                  </div> -->
                </div>
                <div class="text-center mt-4 font-weight-light">
                  Don't have an account?<router-link
                    to="/register"
                    class="text-primary"
                  >
                    Create
                  </router-link>
                </div>
              </BForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//Start - Import Section
import { ref } from "vue";
import { useAuthStore } from "@/store/auth_store";
// import CryptoJS from "crypto-js";
import { AESEncryptData } from "@/utils/common-function";

//end - Import Section

const is_valid_user_name = ref(null);
const is_valid_user_pass = ref(null);
const showPass = ref(false);
const form = ref({
  username: "",
  password: "",
});

const obj_login = ref({});
const auth_store = useAuthStore();

async function onSubmit() {
  if (validateFormInput()) {
    var ciphertext = AESEncryptData(form.value.password);
    obj_login.value = {
      username: form.value.username,
      password: ciphertext, //form.value.password
    };
    auth_store.login(obj_login);
  }
}

const validateFormInput = () => {
  is_valid_user_name.value = form.value.username == "" ? false : true;
  is_valid_user_pass.value = form.value.password == "" ? false : true;
  if (!is_valid_user_name.value || !is_valid_user_pass.value) return false;
  else return true;
};
</script>
